import { render, staticRenderFns } from "./DomainWhoisView.vue?vue&type=template&id=aa6937c2&"
import script from "./DomainWhoisView.vue?vue&type=script&lang=js&"
export * from "./DomainWhoisView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa6937c2')) {
      api.createRecord('aa6937c2', component.options)
    } else {
      api.reload('aa6937c2', component.options)
    }
    module.hot.accept("./DomainWhoisView.vue?vue&type=template&id=aa6937c2&", function () {
      api.rerender('aa6937c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/DomainWhoisView.vue"
export default component.exports